import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { JsonField } from "@shared/helpers/custom-fields";
import { Fields, Relations } from "remult";
import { VolunteerOrgProject } from "../volunteer-org-project";
import { VolunteerOrganization } from "../volunteer-organization";
import { VolunteerOrgProjectAssignmentEntityConfig } from "./config";
import { VolunteerOrgProjectAssignmentFilters } from "./filters";
import { VolunteerOrgProjectAssignmentMethods } from "./methods";

@HyperEntity(
  "volunteer-org-project-assignment",
  VolunteerOrgProjectAssignmentEntityConfig,
)
export class VolunteerOrgProjectAssignment extends extender(
  VolunteerOrgProjectAssignmentFilters,
  VolunteerOrgProjectAssignmentMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "volunteer_organization_id", caption: "שלוחה" })
  volunteerOrganizationId = "";

  @Relations.toOne<VolunteerOrgProjectAssignment, VolunteerOrganization>(
    () => VolunteerOrganization,
    "volunteerOrganizationId",
  )
  volunteerOrganization?: VolunteerOrganization;

  @Fields.string({ dbName: "project_id", caption: "פרויקט" })
  projectId = "";

  @Relations.toOne<VolunteerOrgProjectAssignment, VolunteerOrgProject>(
    () => VolunteerOrgProject,
    "projectId",
  )
  project?: VolunteerOrgProject;

  @Fields.integer({ dbName: "volunteer_count", caption: "מספר מתנדבים" })
  volunteerCount = 0;

  @Fields.string({ caption: "מיקום" })
  address = "";

  @JsonField<VolunteerOrgProjectAssignment, { lat: number; lng: number }>({
    allowedKeys: ["lat", "lng"],
    allowNull: true,
  })
  coordinates?: { lat: number; lng: number } | null;

  @Fields.string({ allowNull: true, caption: "הערות" })
  notes?: string | null;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
